import { dialCodes } from "./country-dial-codes";
export function getCountryDialCode(countryCode) {
    var _a;
    return (_a = dialCodes.find((d) => d.code === countryCode)) === null || _a === void 0 ? void 0 : _a.dial_code;
}
